import { GetterTree } from 'vuex';
import { State } from '@/stores/customers/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public customers = (state: State) => state.customers;
    public contactNames = (state: State) => state.contactNames;
}
